import {
  ThemeRadiusPath,
  Integer,
  ValueByDevice,
  useResponsivePropValue,
  getSize,
} from 'platform/foundation';
import {css, useTheme} from 'styled-components';

import {ReactNode} from 'react';

import {getToken} from 'shared/web';

import {ThemeColorPath} from '../../theme/theme';

type CardOoType = {
  backgroundColor?: ThemeColorPath;
  children?: ReactNode;
  radius?: ThemeRadiusPath;
  padding?: Integer | ValueByDevice<Integer>;
  paddingHorizontal?: Integer | ValueByDevice<Integer>;
  paddingVertical?: Integer | ValueByDevice<Integer>;
  paddingTop?: Integer | ValueByDevice<Integer>;
  paddingLeft?: Integer | ValueByDevice<Integer>;
  paddingRight?: Integer | ValueByDevice<Integer>;
  paddingBottom?: Integer | ValueByDevice<Integer>;
  overflow?: 'hidden';
};

export const CardOo = (props: CardOoType) => {
  const theme = useTheme();
  const padding = useResponsivePropValue(props.padding ?? 5);
  const paddingVertical = useResponsivePropValue(props.paddingVertical);
  const paddingHorizontal = useResponsivePropValue(props.paddingHorizontal);
  const paddingLeft = useResponsivePropValue(props.paddingLeft);
  const paddingRight = useResponsivePropValue(props.paddingRight);
  const paddingTop = useResponsivePropValue(props.paddingTop);
  const paddingBottom = useResponsivePropValue(props.paddingBottom);

  return (
    <div
      css={css`
        border-radius: ${getToken('radii.' + (props.radius ?? 'medium'), theme)};
        background-color: ${getToken(
          'colors.' + (props.backgroundColor ?? 'semantic.bg.subtle'),
          theme
        )};
        padding-top: ${getSize(paddingTop ?? paddingVertical ?? padding ?? 0)};
        padding-left: ${getSize(paddingLeft ?? paddingHorizontal ?? padding ?? 0)};
        padding-right: ${getSize(paddingRight ?? paddingHorizontal ?? padding ?? 0)};
        padding-bottom: ${getSize(paddingBottom ?? paddingVertical ?? padding ?? 0)};
        overflow: ${props.overflow ?? 'visible'};
      `}
    >
      {props.children}
    </div>
  );
};
